import { createContext, useContext } from 'react';
import type { TutorialKapitelId } from '../../tutorial/types';

/**
 * LERNZENTRUM — der Weg ins Lernzentrum für Komponenten, die App.tsx nicht
 * erreicht.
 *
 * Das Kontext-„?" braucht genau einen Rückruf: `handleOpenLernzentrum` aus
 * App.tsx. Als Prop durchgereicht ist das der ehrlichere Weg, und für
 * `AdminView` und `InvoicesView` geht er auch — beide rendert App.tsx selbst.
 *
 * `ProjectHeader` hängt dagegen unter `ProjectHub`, und die Datei ist gerade
 * in fremder Hand (Auftrag A2b, offene Anker). Eine neue Prop dort hätte einen
 * Konflikt in einer Datei erzeugt, die mit dieser Sache nichts zu tun hat.
 * Deshalb dieser Kontext: App.tsx stellt ihn einmal über den ganzen Baum,
 * `ProjectHeader` holt sich den Rückruf selbst. Die Prop bleibt trotzdem
 * vorgesehen — wer den Header künftig direkt versorgt, sticht den Kontext.
 *
 * Ohne Provider ist der Rückruf stumm statt undefined: ein „?" in einem Test
 * oder einer Vorschau soll nichts werfen.
 */

export type LernzentrumOeffner = (kapitelId?: TutorialKapitelId) => void;

const OHNE_PROVIDER: LernzentrumOeffner = () => { /* kein Lernzentrum erreichbar */ };

export const LernzentrumOeffnerContext = createContext<LernzentrumOeffner>(OHNE_PROVIDER);

export const useLernzentrumOeffner = (): LernzentrumOeffner => useContext(LernzentrumOeffnerContext);
